import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import styled from '@emotion/styled';
import { ExtraBoldText, RegularText } from '@/components/text';
import { useGetBusinessCategory } from '@/hooks/CommonRequests';
import { LOCAL_LANGUAGE } from '@/constants/storageKey';
import { Container } from './inquryStyles';
import { mq } from '@/utils/mediaQuery';

const TextWrapper = styled.div(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '2rem 0',
  marginBottom: '2rem',
  whiteSpace: 'break-spaces',
  textAlign: 'center',
}));

const ButtonGroup = styled.div(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '2.4rem',
  justifyContent: 'center',
  width: '100%',
  maxWidth: '60rem',
  margin: '0 auto',

  [mq('tablet')]: {
    gap: '3.2rem',
  },
}));

const ModernCardButton = styled.button(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flex: 1,
  minHeight: '120px',
  border: '1px solid #eaeaea',
  borderRadius: '8px',
  cursor: 'pointer',
  transition: 'all 0.2s ease-in-out',
  fontSize: '1.6rem',
  fontWeight: 600,
  color: '#333333',
  '&:hover': {
    border: `1px solid ${theme.color.base_purple}`,
  },
  '&:active': {
    border: `1px solid ${theme.color.base_purple}`,
  },
}));

const Inquiry = () => {
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const navigate = useNavigate();
  const { data: businessCategory } = useGetBusinessCategory();

  const lang = localStorage.getItem(LOCAL_LANGUAGE) || 'en';
  const baseUrl = lang !== null ? `/${lang}` : '';

  return (
    <Container>
      <TextWrapper>
        <ExtraBoldText id="lang-event-inquiry" fontSize={isMobile ? '3.6rem' : '4.8rem'} />
        <RegularText id="lang-inquiry-description" secondary />
      </TextWrapper>

      <ButtonGroup>
        {businessCategory?.map((category) => (
          <ModernCardButton
            key={category.code_id}
            onClick={() => navigate(`${baseUrl}/inquiry/${category.code_id}`)}
          >
            {category.name}
          </ModernCardButton>
        ))}
      </ButtonGroup>
    </Container>
  );
};

export default Inquiry;
